import { render, staticRenderFns } from "./ListTwo.vue?vue&type=template&id=5c35c01e&scoped=true&"
import script from "./ListTwo.vue?vue&type=script&lang=js&"
export * from "./ListTwo.vue?vue&type=script&lang=js&"
import style0 from "./ListTwo.vue?vue&type=style&index=0&id=5c35c01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35c01e",
  null
  
)

export default component.exports